"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _sortable = require("@dnd-kit/sortable");

var _elements = require("../../../styles/elements");

var _TableRow = _interopRequireDefault(require("../TableRow/TableRow"));

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/jsx-key */
var TableBody = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var page = _ref.page,
      emptyHintVisible = _ref.emptyHintVisible,
      emptyHint = _ref.emptyHint,
      prepareRow = _ref.prepareRow,
      headersCount = _ref.headersCount;

  if (page.length === 0 && emptyHintVisible) {
    return (0, _jsxRuntime.jsxs)("tr", {
      css: [_elements.text.styles.textMediumDark, _elements.text.styles.italic, _elements.text.styles.fontNormal, process.env.NODE_ENV === "production" ? "" : ";label:TableBody;"],
      children: [(0, _jsxRuntime.jsx)("td", {
        children: emptyHint
      }), (0, _toConsumableArray2["default"])(Array(headersCount - 1)).map(function (_, index) {
        return (// eslint-disable-next-line react/no-array-index-key
          (0, _jsxRuntime.jsx)("td", {}, index)
        );
      })]
    });
  }

  return (0, _jsxRuntime.jsx)(_sortable.SortableContext, {
    items: page,
    strategy: _sortable.verticalListSortingStrategy,
    children: page.map(function (row) {
      prepareRow(row);
      return (0, _jsxRuntime.jsx)(_TableRow["default"], {
        row: row
      }, row.getRowProps().key);
    })
  });
});

TableBody.displayName = 'TableBody';
TableBody.propTypes = {
  page: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    cells: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
  })),
  emptyHintVisible: _propTypes.bool,
  emptyHint: _propTypes.string,
  prepareRow: _propTypes.func,
  headersCount: _propTypes.number
};
TableBody.defaultProps = {
  page: [],
  emptyHintVisible: false,
  emptyHint: undefined,
  prepareRow: function prepareRow() {},
  headersCount: 1
};
var _default = TableBody;
exports["default"] = _default;
//# sourceMappingURL=TableBody.js.map